function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { BlobTypes } from '../enums';
import { SortOrder } from '../models';
export var downloadFile = function(data, name, openNewTab, mimeType) {
    var blob = new Blob([
        data
    ], {
        type: mimeType
    });
    var url = URL.createObjectURL(blob);
    var link = document.createElement('a');
    link.href = url;
    if (openNewTab) {
        link.target = '_blank';
    } else {
        link.download = name;
    }
    document.body.append(link);
    link.click();
    link.remove();
    // in case the Blob uses a lot of memory
    setTimeout(function() {
        return URL.revokeObjectURL(link.href);
    }, 7000);
};
export var downloadPDF = function(data, name) {
    var openNewTab = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return downloadFile(data, name, openNewTab, BlobTypes.Pdf);
};
export var downloadCSV = function(data, name) {
    var openNewTab = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return downloadFile(data, name, openNewTab, BlobTypes.Csv);
};
export var downloadDocx = function(data, name) {
    var openNewTab = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return downloadFile(data, name, openNewTab, BlobTypes.Docx);
};
export var deepMergeObjects = function(obj1, obj2) {
    var updateIfExists = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var result = _object_spread({}, obj1);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // eslint-disable-next-line no-restricted-syntax
        for(var _iterator = Object.keys(obj2)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (obj1[key] && obj2[key] && _type_of(obj1[key]) === 'object' && _type_of(obj2[key]) === 'object') {
                var obj = deepMergeObjects(obj1[key], obj2[key]);
                if (Array.isArray(obj1[key]) || Array.isArray(obj2[key])) {
                    result[key] = Object.values(obj);
                } else {
                    result[key] = obj;
                }
            } else if (updateIfExists) {
                if (obj2[key]) result[key] = obj2[key];
            } else {
                result[key] = obj2[key];
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return result;
};
export var advanceDeepMergeObjects = function(obj1, obj2) {
    var result = _object_spread({}, obj1);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // eslint-disable-next-line no-restricted-syntax
        for(var _iterator = Object.keys(obj2)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (obj1[key] && obj2[key] && _type_of(obj1[key]) === 'object' && _type_of(obj2[key]) === 'object') {
                var obj = advanceDeepMergeObjects(obj1[key], obj2[key]);
                if (Array.isArray(obj1[key]) || Array.isArray(obj2[key])) {
                    result[key] = Object.values(obj);
                } else {
                    result[key] = obj;
                }
            } else if (obj2[key]) result[key] = obj2[key];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return result;
};
export var paginationLabelDisplayedRows = function(t) {
    return function(param) {
        var from = param.from, to = param.to, count = param.count;
        return "".concat(from, "–").concat(to, " ").concat(t('common.preps.of'), " ").concat(count !== -1 ? count : "".concat(t('contractorJobs.tabs.moreThan'), " ").concat(to));
    };
};
export var byteToMegabyte = function(fileSize) {
    if (fileSize) {
        return (fileSize / Math.pow(1024, 2)).toFixed(3);
    }
    return 0;
};
export var MAX_WORKPLACE_TYPE_CODES = 3;
export var REGENERATE_LIMIT = 5;
export var MAX_FILE_UPLOAD_UNIT = 1000000;
export var concatAndFormatAiOutput = function(prevValue, message) {
    var formattedResult = message ? message.toString().replace(/\n/g, '<br>') : '';
    if (formattedResult) {
        return prevValue + formattedResult;
    }
    return prevValue;
};
export var concatAndFormatTipsOutput = function(prevValue, message) {
    var formattedResult = message ? message.toString().replace(/\n/g, '') : '';
    if (formattedResult) {
        return prevValue + formattedResult;
    }
    return prevValue;
};
export var concatAndFormatAIOutputWithExtraSpace = function(prevValue, message) {
    var formattedResult = message ? message.toString().replace(/\n\n/g, '<br><br>') : '';
    if (formattedResult) {
        var result = formattedResult.replace(/\n/g, '<br><br>');
        return "".concat(prevValue + result);
    }
    return prevValue;
};
var charArray = [
    '[',
    '\\',
    '&',
    '/',
    '|',
    '!',
    '(',
    ')',
    '{',
    '}',
    '[',
    ']',
    '^',
    '"',
    '~',
    '*',
    '?',
    ':',
    ']'
];
export var getParsedProfileData = function(data) {
    var _data_contactInformation_candidateName, _data_contactInformation, _data_contactInformation_candidateName1, _data_contactInformation1, _data_contactInformation_emailAddresses, _data_contactInformation2, _data_contactInformation_telephones, _data_contactInformation3, _data_contactInformation_location, _data_contactInformation4, _data_contactInformation_location1, _data_contactInformation5, _data_contactInformation_location2, _data_contactInformation6, _data_contactInformation_location3, _data_contactInformation7;
    return {
        firstName: (data === null || data === void 0 ? void 0 : (_data_contactInformation = data.contactInformation) === null || _data_contactInformation === void 0 ? void 0 : (_data_contactInformation_candidateName = _data_contactInformation.candidateName) === null || _data_contactInformation_candidateName === void 0 ? void 0 : _data_contactInformation_candidateName.givenName) || undefined,
        lastName: (data === null || data === void 0 ? void 0 : (_data_contactInformation1 = data.contactInformation) === null || _data_contactInformation1 === void 0 ? void 0 : (_data_contactInformation_candidateName1 = _data_contactInformation1.candidateName) === null || _data_contactInformation_candidateName1 === void 0 ? void 0 : _data_contactInformation_candidateName1.familyName) || undefined,
        email: (data === null || data === void 0 ? void 0 : (_data_contactInformation2 = data.contactInformation) === null || _data_contactInformation2 === void 0 ? void 0 : (_data_contactInformation_emailAddresses = _data_contactInformation2.emailAddresses) === null || _data_contactInformation_emailAddresses === void 0 ? void 0 : _data_contactInformation_emailAddresses.length) ? data.contactInformation.emailAddresses[0] : undefined,
        phone: (data === null || data === void 0 ? void 0 : (_data_contactInformation3 = data.contactInformation) === null || _data_contactInformation3 === void 0 ? void 0 : (_data_contactInformation_telephones = _data_contactInformation3.telephones) === null || _data_contactInformation_telephones === void 0 ? void 0 : _data_contactInformation_telephones.length) ? "".concat((data === null || data === void 0 ? void 0 : data.contactInformation.telephones[0].areaCityCode) || '').concat((data === null || data === void 0 ? void 0 : data.contactInformation.telephones[0].subscriberNumber) || '').replace(/\D+/g, '') : undefined,
        address: (data === null || data === void 0 ? void 0 : (_data_contactInformation4 = data.contactInformation) === null || _data_contactInformation4 === void 0 ? void 0 : (_data_contactInformation_location = _data_contactInformation4.location) === null || _data_contactInformation_location === void 0 ? void 0 : _data_contactInformation_location.streetAddressLines) || undefined,
        city: (data === null || data === void 0 ? void 0 : (_data_contactInformation5 = data.contactInformation) === null || _data_contactInformation5 === void 0 ? void 0 : (_data_contactInformation_location1 = _data_contactInformation5.location) === null || _data_contactInformation_location1 === void 0 ? void 0 : _data_contactInformation_location1.municipality) || undefined,
        countryCode: (data === null || data === void 0 ? void 0 : (_data_contactInformation6 = data.contactInformation) === null || _data_contactInformation6 === void 0 ? void 0 : (_data_contactInformation_location2 = _data_contactInformation6.location) === null || _data_contactInformation_location2 === void 0 ? void 0 : _data_contactInformation_location2.countryCode) || undefined,
        zip: (data === null || data === void 0 ? void 0 : (_data_contactInformation7 = data.contactInformation) === null || _data_contactInformation7 === void 0 ? void 0 : (_data_contactInformation_location3 = _data_contactInformation7.location) === null || _data_contactInformation_location3 === void 0 ? void 0 : _data_contactInformation_location3.postalCode) || undefined
    };
};
export var getCurrentDate = function() {
    return new Date().toISOString();
};
export var stringToBoolean = function(val) {
    return val === 'false' ? false : !!val;
};
export var getProperty = function(obj, propNested) {
    if (!obj || !propNested) {
        return '';
    }
    if (propNested.length === 1) {
        var key = propNested[0];
        return obj[key];
    }
    var newObj = propNested.shift();
    return getProperty(obj[newObj], propNested);
};
export var comparator = function(a, b) {
    if (!a) {
        if (!b) {
            return 0;
        }
        return 1;
    }
    if (!b) {
        return -1;
    }
    if (typeof a === 'boolean' || typeof b === 'boolean') {
        return a.toString().localeCompare(b.toString());
    }
    return a.localeCompare(b);
};
export var stringComparator = function(a, b) {
    return comparator(a.toLowerCase(), b.toLowerCase());
};
export var configItemComparator = function(a, b, sortType) {
    var _a_value, _b_value, _a_value1, _b_value1;
    return (sortType === null || sortType === void 0 ? void 0 : sortType.order) === SortOrder.desc ? -comparator(a === null || a === void 0 ? void 0 : (_a_value = a.value) === null || _a_value === void 0 ? void 0 : _a_value.toLowerCase(), (_b_value = b.value) === null || _b_value === void 0 ? void 0 : _b_value.toLowerCase()) : comparator(a === null || a === void 0 ? void 0 : (_a_value1 = a.value) === null || _a_value1 === void 0 ? void 0 : _a_value1.toLowerCase(), (_b_value1 = b.value) === null || _b_value1 === void 0 ? void 0 : _b_value1.toLowerCase());
};
export var getComparator = function(a, b, sortType) {
    var aProp = getProperty(a, sortType.field.split('.'));
    var bProp = getProperty(b, sortType.field.split('.'));
    return sortType.order === SortOrder.desc ? -comparator(aProp, bProp) : comparator(aProp, bProp);
};
export var transform = function(val) {
    var characters = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : charArray;
    var str = val;
    characters.forEach(function(char) {
        // Escape special characters before using them in the regular expression
        var escapedChar = char.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        if (str.includes(char)) {
            str = str.replace(new RegExp(escapedChar, 'g'), "\\".concat(char));
        }
    });
    return str;
};
export var isValidDate = function(date) {
    if (date) {
        var minDate = new Date(0);
        var currentDate = new Date(date);
        if (currentDate.getTime() > minDate.getTime()) {
            return true;
        }
    }
    return false;
};
export var convertStringToFloat = function(rate) {
    var _rate_split_;
    return +parseFloat(rate.replace(/,/g, '')).toFixed(((_rate_split_ = rate.split('.')[1]) === null || _rate_split_ === void 0 ? void 0 : _rate_split_.length) || 0);
};
export var updateAddressWithStateIsoCode = function(address) {
    if (!address) return address;
    return _object_spread_props(_object_spread({}, address), {
        stateIsoCode: address.countryCode && address.stateCode ? "".concat(address.countryCode, "-").concat(address.stateCode) : null
    });
};
export var includesWithLowerCase = function(property, searchStr) {
    return (property !== null && property !== void 0 ? property : '').toLowerCase().includes(searchStr);
};
export var getUniqueCandidates = function(candidates) {
    return candidates === null || candidates === void 0 ? void 0 : candidates.reduce(function(accumulator, current) {
        if (!accumulator.find(function(obj) {
            return obj.id === current.id;
        })) {
            accumulator.push(current);
        }
        return accumulator;
    }, []);
};
export var shallowCompare = function(obj1, obj2) {
    return Object.keys(obj1).length === Object.keys(obj2).length && Object.keys(obj1).every(// eslint-disable-next-line no-prototype-builtins
    function(key) {
        return obj2.hasOwnProperty(key) && obj1[key] === obj2[key];
    });
};
export var getPlainText = function(text) {
    return text === null || text === void 0 ? void 0 : text.replace(/<[^>]*>|&nbsp;/g, '');
};
export var getDropzoneColor = function(props) {
    if (props.isFocused) {
        return '#008BCC';
    }
    if (props.isDragAccept) {
        return props.theme.palette.success.main;
    }
    if (props.isDragReject) {
        return props.theme.palette.error.main;
    }
    return props.isGorillaTheme ? props.theme.palette.primary.main : '#0000003b';
};
export var groupBy = function(array, key) {
    return array === null || array === void 0 ? void 0 : array.reduce(function(acc, obj) {
        var _acc_keyValue;
        var keyValue = obj[key];
        if (!acc[keyValue]) {
            acc[keyValue] = [];
        }
        (_acc_keyValue = acc[keyValue]) === null || _acc_keyValue === void 0 ? void 0 : _acc_keyValue.push(obj);
        return acc;
    }, {});
};
export var replaceOperators = function(inputString) {
    var replacedSentence = inputString.replace(/("[^"]*"|\band\b|\bor\b)/gi, function(match) {
        if (match.startsWith('"') && match.endsWith('"')) {
            return match // Keep double quoted strings intact
            ;
        }
        return match === 'and' ? '+' : '|';
    });
    return replacedSentence;
};
export var capitalizeOperators = function(inputString) {
    var capitalizedSentence = inputString.replace(/("[^"]*"|\band\b|\bor\b)/gi, function(match) {
        if (match.startsWith('"') && match.endsWith('"')) {
            return match // Keep double quoted strings intact
            ;
        }
        // Capitalize the operator by converting it to uppercase
        return match.toUpperCase();
    });
    return capitalizedSentence;
};
export function findAllValuesByKey(obj, targetKey) {
    var values = [];
    function search(obj2) {
        Object.entries(obj2).forEach(function(param) {
            var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
            if (key === targetKey) {
                values.push(value);
            }
            // If the value is an object, recurse deeper
            if ((typeof value === "undefined" ? "undefined" : _type_of(value)) === 'object' && value !== null) {
                search(value);
            }
        });
    }
    search(obj);
    return values.filter(function(value) {
        return !!value;
    });
}
export var regexToExtractCode = /"code": "([^"]+)"/;
export var SKIP_SURVEY_DURATION = 182;
export var MAX_AI_GENERATED_SCREENING_QUESTIONS = 3;
export var TERMS_OF_USE_AND_PRIVACY_POLICY_EFFECTIVE_DATE = 'March 2024';
export var getUserName = function(currentUser, t) {
    if ((currentUser === null || currentUser === void 0 ? void 0 : currentUser.isAccessRestricted) && (currentUser === null || currentUser === void 0 ? void 0 : currentUser.displayName) !== ' ') return currentUser.displayName;
    if ((currentUser === null || currentUser === void 0 ? void 0 : currentUser.isAccessRestricted) && (currentUser === null || currentUser === void 0 ? void 0 : currentUser.email)) return currentUser === null || currentUser === void 0 ? void 0 : currentUser.email;
    if (currentUser === null || currentUser === void 0 ? void 0 : currentUser.isGuestUser) return t('drawer.guestUser');
    if ((currentUser === null || currentUser === void 0 ? void 0 : currentUser.firstName) && (currentUser === null || currentUser === void 0 ? void 0 : currentUser.lastName)) return currentUser.displayName;
    return '---';
};
